import React, { useMemo } from 'react';
import { useAppSelector } from 'src/utils/Hooks';
import { SearchSelect } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/components/SearchSelect';
import { usePresentationFormContext } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/PresentationFormContext';
import { getFieldConfig } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/constants/formConfigs';

const retailerIdsToExclude = new Set(['6', '35', '73', '74', '77', '90']);

export const RetailerSelect = () => {
  const {
    selections: { control },
    currentFormConfig
  } = usePresentationFormContext();
  
  const { availableRetailers } = useAppSelector((state) => state.retailer);
  const {
    config: { allRetailerIds }
  } = useAppSelector((state) => state.user);

  // Get field configuration
  const retailerConfig = getFieldConfig(currentFormConfig, 'retailerIds');

  const retailersData = useMemo(() =>
    availableRetailers.filter(
      (retailer) => !retailerIdsToExclude.has(retailer.id) && allRetailerIds.includes(Number(retailer.id))
    ), [availableRetailers, allRetailerIds]);

  const selectOptions = retailersData.map((datum) => {
    return { id: datum.id, value: datum.id.toString(), displayName: datum.displayName };
  });

  // Build dynamic placeholder based on config
  const getPlaceholder = () => {
    const { minCount, maxCount } = retailerConfig;
    const hasMin = minCount !== undefined && minCount > 0;
    const hasMax = maxCount !== undefined;
    
    if (hasMin && hasMax) {
      if (minCount === maxCount) {
        return `Select exactly ${minCount} retailer${minCount > 1 ? 's' : ''}`;
      }
      return `Select ${minCount} to ${maxCount} retailers`;
    }
    if (hasMin) {
      return `Select at least ${minCount} retailer${minCount > 1 ? 's' : ''}`;
    }
    if (hasMax) {
      return `Select up to ${maxCount} retailer${maxCount > 1 ? 's' : ''}`;
    }
    return 'Search or select retailers you would like to add to your presentation (currencies will be normalized)';
  };

  return (
    <SearchSelect
      name="retailerIds"
      title="Retailer Inclusions"
      placeholder={getPlaceholder()}
      selectOptions={selectOptions}
      isMulti={true}
      maxCount={retailerConfig.maxCount}
      control={control}
    />
  );
};
